<template>
  <div class="customer">
    <h2 class="fs30">我们的部分客户</h2>
    <div class="banner">
      <div class="imgs">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon1%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon2%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon3%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon4%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon5%402x.png" />
      </div>
      <div class="imgs">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon6%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon7%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon8%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon9%402x.png" />
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_client_icon10%402x.png" />
      </div>  
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  .customer{
    position: relative;
    margin: auto;
    background-color: #fafafa;
  }
  .banner {
    max-width: 1200px;
    overflow: hidden;
    margin: 0 auto;
    padding-bottom: 50px;
  }
  .imgs {
    font-size: 0;
    margin-bottom: 32px;
  }
  .banner img{
    line-height: 0;
    font-size: 0;
    width: 18%;
    font-size: 0;
  }
  .banner img+img {
    margin-left: 2.5%;
  }
  .customer h2 {
    text-align: center;
    padding: 80px 0 60px 0;
  }
  .fs30 {
    font-size: 30px;
  }
  @media (max-width: 1199px) and (min-width: 992px){
    .customer h2 {
      text-align: center;
      padding: 60px 0;
    }
    .fs30 {
      font-size: 28px;
    }
    .banner {
      padding: 0 10px 30px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .customer h2 {
      text-align: center;
      padding: 40px 0;
    }
    .fs30 {
      font-size: 26px;
    }
    .banner {
      height: 250px;
      padding: 0 10px 30px;
    }
  }
  @media screen and (max-width: 767px){
    .banner{
      padding: 0 10px 30px;
      height: 150px;
    }
    .customer h2 {
      text-align: center;
      padding: 27px 0;
      font-size: 20px;
      line-height: 24px;
    }
    .fs30 {
      font-size: 24px;
    }
  }
  @media (min-width: 768px){
  }
</style>




// WEBPACK FOOTER //
// src/components/index/customer/customer.vue